import React from 'react';
import KeyVisual from '../UI/ResponsiveImageSet/ResponsiveImageSet';
import KeyVisualXs from '../../assets/images/keyvisual-xs-rgb.webp';
import KeyVisualLg from '../../assets/images/keyvisual-lg-rgb.webp';
import PageNotFoundHeader from './PageNotFoundHeader';
import HeroTitle from './HeroTitle';
import HeroLeadGraphic from './HeroLeadGraphic';
import HeroCTA from './HeroCTA';
import { useHeroConfig, useKeyVisualConfig } from '../../store/designStore';
import { getCardStyle } from './heroUtils';
import styles from './HeroBackground.module.scss';

const HeroBackground = ({ pageNotFound, maxOverlayHeight }) => {
    const heroConfig = useHeroConfig();
    const {
        isFullWidth: isKeyVisualFullWidth,
        breakpoints: keyVisualBreakpoints,
        altText: keyVisualAltText,
    } = useKeyVisualConfig();

    const isSplit =
        heroConfig.background === 'keyVisual' &&
        (heroConfig.keyVisualSplit === 'split-left' || heroConfig.keyVisualSplit === 'split-right');

    return (
        <div className={isKeyVisualFullWidth ? 'container-fluid px-0' : 'container-lg px-0'}>
            {pageNotFound ? (
                <PageNotFoundHeader />
            ) : heroConfig.background === 'solid' ? (
                <div
                    className={`w-100 ${styles.solidBackground} ${isKeyVisualFullWidth ? styles.fullWidth : ''}`}
                    style={{
                        backgroundColor: heroConfig.solidColor || undefined,
                        minHeight: maxOverlayHeight > 0 ? `${maxOverlayHeight}px` : undefined,
                    }}
                />
            ) : (
                <div
                    className={`${styles.heroBackgroundContainer} ${
                        heroConfig.keyVisualSplit === 'split-left' ? styles.splitLeft : ''
                    } ${heroConfig.keyVisualSplit === 'split-right' ? styles.splitRight : ''} ${
                        isKeyVisualFullWidth ? styles.fullWidth : ''
                    }`}
                    style={{
                        backgroundColor: heroConfig.solidColor || 'transparent',
                        minHeight: maxOverlayHeight > 0 ? `${maxOverlayHeight}px` : undefined,
                    }}
                >
                    {(heroConfig.keyVisualSplit === 'split-left' || heroConfig.keyVisualSplit === 'split-right') && (
                        <div className={styles.naturalHeightDummy} aria-hidden="true">
                            <KeyVisual
                                imageXs={KeyVisualXs}
                                imageLg={KeyVisualLg}
                                breakpoints={keyVisualBreakpoints}
                                altText=""
                            />
                        </div>
                    )}
                    <div className={styles.keyVisualWrapper}>
                        <KeyVisual
                            imageXs={KeyVisualXs}
                            imageLg={KeyVisualLg}
                            breakpoints={keyVisualBreakpoints}
                            altText={keyVisualAltText}
                        />
                    </div>
                    {isSplit && (
                        <div className={`d-block d-md-none ${styles.mobileSplitContent}`}>
                            {heroConfig.title?.hasTitle && (
                                <div className={styles.pointerEventsNone}>
                                    <HeroTitle titleConfig={heroConfig.title} />
                                </div>
                            )}
                            {heroConfig.leadGraphic?.hasLeadGraphic && (
                                <div className={styles.pointerEventsNone}>
                                    <HeroLeadGraphic leadGraphicConfig={heroConfig.leadGraphic} />
                                </div>
                            )}
                            {heroConfig.cta?.hasCTA && (
                                <div
                                    className={
                                        heroConfig.cta?.card?.hasNoCard
                                            ? styles.ctaNoCard
                                            : `card text-start ${styles.ctaCard}`
                                    }
                                    style={
                                        heroConfig.cta?.card?.hasNoCard
                                            ? { pointerEvents: 'auto' }
                                            : {
                                                  pointerEvents: 'auto',
                                                  ...getCardStyle(heroConfig.cta),
                                              }
                                    }
                                >
                                    <HeroCTA ctaConfig={heroConfig.cta} />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default HeroBackground;
